import { render, staticRenderFns } from "./ivestor.vue?vue&type=template&id=0c6805f9&scoped=true"
import script from "./ivestor.vue?vue&type=script&lang=js"
export * from "./ivestor.vue?vue&type=script&lang=js"
import style0 from "./ivestor.vue?vue&type=style&index=0&id=0c6805f9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6805f9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TailwindBreakpoints: require('/vercel/path0/components/TailwindBreakpoints.vue').default})
